import PropTypes from 'prop-types'
import { isNil } from 'ramda'

import Location from 'model/person/locations/location'

const HOME = 'home_address'
const WORK = 'work_address'
const OTHER = 'other_address'

class CustomLocation extends Location {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._address = init.address
    this._name = init.name
    this._is_preferred = init.is_preferred
    this._kind = init.kind
  }

  static shape = {
    ...Location.shape,
    id: PropTypes.string.isRequired,
    address: PropTypes.string,
    name: PropTypes.string,
    is_preferred: PropTypes.bool,
    kind: PropTypes.string
  }

  get id() {
    return this._id
  }

  get address() {
    return this._address
  }

  get name() {
    return this._name
  }

  get is_preferred() {
    return this._is_preferred
  }

  get kind() {
    return this._kind
  }

  // Calculable
  get getName() {
    const postfix = this.is_preferred ? '(Preferred)' : ''
    switch (this.kind) {
      case HOME:
        return `Home ${postfix}`
      case WORK:
        return `Work ${postfix}`
      case OTHER:
      default:
        return `${this.name} ${postfix}`
    }
  }
}

export default CustomLocation
